/* ws-cart-addon.js — <ws-cart-addon> (cart-drawer add-on row, offer architecture K, 2026-09-02).
   One job: add the row's variant to the cart and repaint the drawer through the SAME path the
   product form uses (cart-drawer.renderContents on the /cart/add.js JSON with sections), so the
   drawer, subtotal and header bubble update together and the row disappears because Liquid no
   longer renders it (the disc set is now a cart line). Double-submit guarded; errors render in
   the row, never as an alert. Loaded once from snippets/cart-drawer.liquid; the element is
   re-created on every drawer repaint, so state lives on the element, not in this module. */
(function () {
  if (customElements.get('ws-cart-addon')) return;

  class WsCartAddon extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-ws-cart-addon-btn]');
      this.err = this.querySelector('.ws-cart-addon__error');
      this.busy = false;
      if (this.btn) this.btn.addEventListener('click', this.add.bind(this));
    }

    setBusy(on) {
      this.busy = on;
      if (!this.btn) return;
      this.btn.setAttribute('aria-disabled', on ? 'true' : 'false');
      const label = this.btn.querySelector('.ws-cart-addon__btn-label');
      const busy = this.btn.querySelector('.ws-cart-addon__btn-busy');
      if (label) label.hidden = on;
      if (busy) busy.hidden = !on;
    }

    showError(msg) {
      if (!this.err) return;
      this.err.textContent = msg || 'Something went wrong. Please try again.';
      this.err.hidden = false;
    }

    add() {
      if (this.busy) return;
      const variantId = Number(this.dataset.variantId);
      if (!variantId) return this.showError();
      this.setBusy(true);
      if (this.err) this.err.hidden = true;

      const drawer = document.querySelector('cart-drawer');
      const sections = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((s) => s.id).join(',')
        : 'cart-drawer,cart-icon-bubble';
      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sections, sections_url: window.location.pathname }),
      })
        .then((r) => r.json())
        .then((json) => {
          if (json.status) throw new Error(json.description || json.message || 'Could not add this item.');
          if (drawer && typeof drawer.renderContents === 'function' && json.sections) {
            if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
            drawer.renderContents(json);
            /* Deliberately NO publish(cartUpdate): renderContents already repaints the drawer + header
               bubble from the add.js sections. Publishing made cart.js re-fetch the CART PAGE section
               and splice its markup ("Your cart / Continue shopping", page-style lines) into the drawer
               — the duplicate-header defect caught by adversarial QC 2026-09-02. */
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch((e) => {
          this.setBusy(false);
          this.showError(e && e.message);
        });
    }
  }

  customElements.define('ws-cart-addon', WsCartAddon);
})();
